// extracted by mini-css-extract-plugin
export var exam = "styles-module--exam--7f036";
export var exams = "styles-module--exams--cee0e";
export var examsContainer = "styles-module--examsContainer--efc17";